<div class="c-title--subsection text-uppercase">DETAILS</div>
<div class="row row--builder">
    <div class="col--builder col-sm-12">
        <div class="c-form-group" *ngIf="(sharedService.catalogLayoutConfig.highlightedStyle == 'list' || sharedService.catalogLayoutConfig.promotedStyle == 'list' || (!sharedService.catalogLayoutConfig.highlightedStyle && !sharedService.catalogLayoutConfig.promotedStyle))">
            <ccl-simple-select ariaLabel="Highlighted Sessions"
                [listOfItems]="displayAs"
                (valueChange)="sessionDataConfig.displayAs = $event.value"
                [value]="sessionDataConfig.displayAs"
                [bindLabel]="'label'"
                [bindValue]="'code'"
                [isClearable]="false"
            >
            </ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
        <div class="c-form-group" *ngIf="sharedService.catalogLayoutConfig.highlightedStyle == 'card' || sharedService.catalogLayoutConfig.promotedStyle == 'card'">
            <ccl-simple-select ariaLabel="Highlighted Sessions"
                [listOfItems]="displayAsHighlighted"
                (valueChange)="sessionDataConfig.displayAs = $event.value"
                [value]="displayAsHighlighted[0].code"
                [bindLabel]="'label'"
                [bindValue]="'code'"
                [isClearable]="false"
            >
            </ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<div class="highlighted-admin-session-list">
    <ccl-list
        #tempSessionList
        [list]="selectedSessions"
        [columns]="columns"
        [hideFilters]="true"
        [compact]="true"
        hasSelectableColumns="false"
        [draggable]="true"
        (filterChangeEvent)="loadFilteredSessions($event)"
        contentRef="contentRef"
        [showPagination]="false"
    >
        There are no {{ this.sharedService.sessionUrl == "highlighted" ? "Highlighted" : "Promoted" }} Sessions
        selected. Click <a href="JAVASCRIPT:void(0)" (click)="openDrawer($event)">here</a> to start your
        selection(s).</ccl-list
    >
</div>
<ccl-basic-button
    (clickEvent)="openDrawer($event)"
    buttonStyle="c-btn-add--primary--small"
    [isDisabled]="false"
    *ngIf="selectedSessions.data != null && selectedSessions.data.length > 0 && !(selectedSessions.data.length == 10)"
>
    <span style="margin-left: 25px;">Add more session(s)</span>
</ccl-basic-button>
